var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("section", { staticClass: "section-about-cleaners" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "card d-none d-sm-block" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.home.who_is_your_cleaner_detail")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-4 text-center" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "button button-large -cyan",
                    attrs: { to: "/booking/start" }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("message.hero.action_button")) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-description d-block d-sm-none" }, [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.home.who_is_your_cleaner_detail")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4 text-center" },
            [
              _c(
                "router-link",
                {
                  staticClass: "button button-large -cyan",
                  attrs: { to: "/booking/start" }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("message.hero.action_button")) +
                      "\n          "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "section-padding" }, [
      _c("div", { staticClass: "row mb-5" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v(
              _vm._s(_vm.$t("message.about_the_cleaners.selection_process"))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-4" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2"
              },
              [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.about_the_cleaners.selection_detail01")
                    )
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2"
              },
              [
                _c("div", { staticClass: "selection-step" }, [
                  _c("div", [_vm._v("1")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.about_the_cleaners.selection_step01")
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "selection-step" }, [
                  _c("div", [_vm._v("2")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.about_the_cleaners.selection_step02")
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "selection-step" }, [
                  _c("div", [_vm._v("3")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.about_the_cleaners.selection_step03")
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2" },
            [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("message.about_the_cleaners.selection_detail02")
                  )
                )
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d60e73f2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d60e73f2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/AboutCleaners.vue
// module id = 1464
// module chunks = 0